import Freezeframe from "freezeframe";

const GIF_SELECTOR = [
	".media-text-cta-block img[data-bmo-gif]",
	".cta-block img[data-bmo-gif]",
	".exhibit-two-images-block img[data-bmo-gif]",
	".intro-with-images-block img[data-bmo-gif]",
].join(", ");
const CONTROL_CLASS = "bmo-gif-control";

function initializeGif(image) {
	// Skip broken images and avoid wrapping an already initialized GIF twice.
	if (!image.naturalWidth || image.closest(`.${CONTROL_CLASS}`)) return;

	// Wrap only the image so its caption remains outside the playback control.
	const button = document.createElement("button");
	button.type = "button";
	button.className = CONTROL_CLASS;
	// Cropped blocks use this ratio to size the image before Freezeframe captures it.
	button.style.setProperty("--bmo-gif-aspect-ratio", image.naturalWidth / image.naturalHeight);
	button.setAttribute("aria-label", "Play animation");
	image.before(button);
	button.append(image);

	const animation = new Freezeframe(image, {
		trigger: false, // Our event handlers control playback instead of Freezeframe.
		responsive: true,
	});

	bindPlaybackControls(button, animation);
}

function bindPlaybackControls(button, animation) {
	let isPlaying = false;
	let wasPlayingBeforePointer;

	const setPlaying = (shouldPlay) => {
		isPlaying = shouldPlay;

		if (shouldPlay) {
			animation.start();
		} else {
			animation.stop();
		}

		// Keep the visual overlay and accessible button label in sync with playback.
		button.classList.toggle("is-playing", shouldPlay);
		button.setAttribute("aria-label", shouldPlay ? "Pause animation" : "Play animation");
	};

	// Match the gallery: preview on hover/focus, then freeze on leave/blur.
	button.addEventListener("mouseenter", () => setPlaying(true));
	button.addEventListener("mouseleave", () => setPlaying(false));
	button.addEventListener("focus", () => setPlaying(true));
	button.addEventListener("blur", () => setPlaying(false));

	button.addEventListener("pointerdown", () => {
		// A tap can focus the button and start playback before its click fires.
		wasPlayingBeforePointer = isPlaying;
	});

	button.addEventListener("click", (event) => {
		// Keyboard clicks have detail === 0 and toggle the current playback state.
		// Pointer clicks toggle the state captured before focus changed it.
		const isPointerClick = event.detail > 0;
		let wasPlaying = isPlaying;

		if (isPointerClick && wasPlayingBeforePointer !== undefined) {
			wasPlaying = wasPlayingBeforePointer;
		}

		setPlaying(!wasPlaying);
		wasPlayingBeforePointer = undefined;
	});
}

function initializeWhenVisible(image) {
	// Featured CTA has separate responsive images. Capturing a hidden image
	// produces a zero-size canvas, so wait until its layout is visible.
	if (image.getClientRects().length) {
		initializeGif(image);
		return;
	}

	const observer = new IntersectionObserver((entries) => {
		if (entries.some((entry) => entry.isIntersecting)) {
			initializeGif(image);
			observer.disconnect();
		}
	});
	observer.observe(image);
}

export default function initializeBlockGifs() {
	document.querySelectorAll(GIF_SELECTOR).forEach((image) => {
		// Freezeframe needs a loaded image to capture its still frame. This also
		// handles lazy-loaded images that have not entered the viewport yet.
		if (image.complete) {
			initializeWhenVisible(image);
		} else {
			image.addEventListener("load", () => initializeWhenVisible(image), { once: true });
		}
	});
}
